<template>
  <div>
    <Navbar type="bg-transparent-sticky" />
    <div class="hero-container-thin">
      <div class="hero-opacity" />
      <img class="hero-image" src="../assets/gdq_hero.jpg" alt="hero image" />
    </div>
    <Breadcrumb />
    <div class="border-0 mx-auto container-xl">
      <div class="title-area">
        <h1 class="page-title h2 mb-2">ToT materials</h1>
      </div>
      <b-form-input
        v-model="search"
        type="search"
        placeholder="Search materials"
        class="mb-3"
        @keyup="totmaterials_get"
      />
      <b-table
        id="materials"
        ref="materials"
        hover
        :items="materials"
        :fields="fields"
        :busy="loading"
        :sort-by="orderby"
        :sort-desc="orderdesc"
        :no-local-sorting="true"
        @sort-changed="materials_sort"
        @row-clicked="showmaterial"
      >
        <template v-slot:cell(material_heading)="data">
          <fa-icon
            v-if="data.item.material_extension=='doc'||data.item.material_extension=='docx'"
            name="file-word"
          />
          <fa-icon
            v-if="data.item.material_extension=='xls'||data.item.material_extension=='xlsx'"
            name="file-excel"
          />
          <fa-icon
            v-if="data.item.material_extension=='ppt'||data.item.material_extension=='pptx'"
            name="file-powerpoint"
          />
          <fa-icon
            v-if="data.item.material_extension=='pdf'"
            name="file-pdf"
          />
          {{ data.item.material_heading }}
        </template>
      </b-table>
    </div>
  </div>
</template>
<script>
import Navbar from './Navbar.vue'
import Breadcrumb from './Breadcrumb.vue'
import { config } from '../../config'
const fields = [
  { key: 'material_heading', label: 'Heading', sortable: true },
  { key: 'material_date', label: 'Published date', sortable: true, tdClass: 'text-right', thClass: 'text-right' }
]

export default {
  name: 'TOTMaterials',
  components: {
    Navbar,
    Breadcrumb
  },
  data () {
    return {
      fields: fields,
      materials: [],
      usergroup_id: 8,
      loading: false,
      currentPage: 1,
      perPage: 999999,
      orderby: 'material_heading',
      order: 'ASC',
      orderdesc: false,
      search: ''
    }
  },
  created () {
    this.totmaterials_get()
  },
  methods: {
    showmaterial (item) {
      var reporturl = config.report_url + '/gdq_materials.php?r=' + item.id
      var downloadURL = new URL(reporturl)
      var downloadLink = document.createElement('a')
      downloadLink.href = downloadURL
      downloadLink.setAttribute('download', 'GDQ_Material_' + item.id + '.' + item.material_extension)
      document.body.appendChild(downloadLink)
      downloadLink.click()
    },
    materials_sort () {
    },
    totmaterials_get () {
      this.loading = true
      var filter = ''
      if (this.search !== '') {
        filter = {
          material_heading: {
            operator: 'LIKE',
            value: '%' + this.search + '%'
          }
        }
      } else {
        filter = {
          id: {
            operator: ' > ',
            value: 0
          }
        }
      }
      if (this.usergroup_id != 0) {
        filter.material_usergroup_id = {
          operator: ' = ',
          value: this.usergroup_id
        }
      }
      this.$store.dispatch('materials_fetch', {
        start: this.currentPage - 1,
        limit: this.perPage,
        orderby: this.orderby,
        order: (this.orderdesc === false) ? 'ASC' : 'DESC',
        filter: filter,
        usergroup_id: this.filterusergroup
      })
        .then((resp) => {
          this.materials = []
          var item
          var ext
          for (var i = 0; i < resp.data.result.length; i++) {
            item = resp.data.result[i]
            ext = item.material_extension.toLowerCase()
            var result = {
              id: item.id,
              material_heading: item.material_heading,
              material_date: item.material_date,
              material_extension: ext
            }
            this.materials.push(result)
          }
          this.rows = resp.data.total
          this.loading = false
        })
    }
  }
}
</script>
<style>
</style>
